import '../../enums/billing/AccountGlobalStatusEnum.es.js';
import '../../enums/billing/AccountingStatusEnum.es.js';
import '../../enums/billing/AssetPurchaseFormatEnum.es.js';
import '../../enums/billing/AssetPurchaseUnavailableCodeEnum.es.js';
import '../../enums/billing/BillingSystemEnum.es.js';
import '../../enums/billing/CreditKindEnum.es.js';
import '../../enums/billing/InvoiceStatusEnum.es.js';
import '../../enums/billing/DiscountTypeEnum.es.js';
import '../../enums/billing/PlanFrequencyEnum.es.js';
import '../../enums/billing/ServiceOffersKindEnum.es.js';
import '../../enums/billing/ServiceStatusEnum.es.js';
import '../../enums/billing/SubscriptionStatusEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTypeEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTimingEnum.es.js';
import '../../enums/billing/SubscriptionServiceOfferEnum.es.js';
import '../../enums/billing/BillingCommitmentEnum.es.js';
import '../../enums/collaboration/ActorEnum.es.js';
import '../../enums/collaboration/EntityTypeEnum.es.js';
import '../../enums/AppHomePageEnum.es.js';
import '../../enums/ApplicationEnum.es.js';
import '../../enums/CreditCardEnum.es.js';
import '../../enums/DollarSignCurrenciesEnum.es.js';
import '../../enums/DownloadBinStatusEnum.es.js';
import '../../enums/ExternalTypeEnum.es.js';
import '../../enums/FeatureEnum.es.js';
import '../../enums/FeatureFlagEnum.es.js';
import '../../enums/FileSelectionSourceEnum.es.js';
import '../../enums/GenresEnum.es.js';
import '../../enums/IntensityEnum.es.js';
import '../../enums/InternalErrorEnum.es.js';
import '../../enums/LibraryItemEnum.es.js';
import '../../enums/MasteringStyleEnum.es.js';
import '../../enums/MfeApplicationEnum.es.js';
import '../../enums/NotificationTypeEnum.es.js';
import '../../enums/PaymentCycleEnum.es.js';
import '../../enums/PaymentMethodEnum.es.js';
import '../../enums/ProofOfRightsEnums.es.js';
import '../../enums/RegexPatternsEnum.es.js';
import { ReleaseContributorRoleEnum } from '../../enums/ReleaseContributorRoleEnum.es.js';
import '../../enums/ReleaseGlobalStateEnum.es.js';
import '../../enums/ReleaseLanguagesEnum.es.js';
import '../../enums/ReleasePayoutStatusEnum.es.js';
import '../../enums/ReleasePayoutGlobalStatusEnum.es.js';
import '../../enums/ReleaseStateEnum.es.js';
import { ServiceProviderStateEnum } from '../../enums/ServiceProviderStateEnum.es.js';
import { ReleaseStoreCategoryEnum } from '../../enums/ReleaseStoreCategoryEnum.es.js';
import { ReleaseStoreEnum } from '../../enums/ReleaseStoreEnum.es.js';
import '../../enums/ReleaseTerritoriesEnum.es.js';
import '../../enums/ReleaseParentalWarningEnum.es.js';
import '../../enums/SessionFlagsEnum.es.js';
import '../../enums/ShareReactionTypeEnum.es.js';
import '../../enums/SocialNetworksEnum.es.js';
import '../../enums/StateEnum.es.js';
import '../../enums/TrackTypeEnum.es.js';
import '../../enums/UnavailabilityEnum.es.js';
import '../../enums/UserInteractionSourceEnum.es.js';
import '../../enums/ZeroDecimalCurrenciesEnum.es.js';
import '../../enums/NoiseReductionLevelEnum.es.js';
import '../../enums/ReleaseDspsEnum.es.js';
import '../../enums/ReleaseDspStatusEnum.es.js';
import '../../enums/ProjectsCallSourceTypesEnum.es.js';
import '../../enums/LibraryItemTypeEnum.es.js';
import '../../enums/PendingItemStateEnum.es.js';
import { MonetizationEligibilityStateEnum } from '../../enums/MonetizationEligibilityStateEnum.es.js';
import { CoverSongOptionsEnum } from '../../enums/CoverSongOptionsEnum.es.js';
import '../../enums/LanguagesEnum.es.js';
import '../../enums/LocalesEnum.es.js';
import { mockBuilder } from '../../utils/builderHelper.es.js';
import { ReleaseArtist, ReleaseArtistV2, ReleaseSongwriter, ReleaseLyricist, ReleasePublisher, ReleaseContributor, ReleaseStore, ReleaseError, ReusedTrackInfos, ReleaseTrack, ReleaseTrackCoverInfos, Release, ReleaseServiceProviderState, ReleaseTrendsDailyTotal } from './Release.es.js';

/** @module Mocks */ /** typedoc */
function aReleaseArtist() {
    return mockBuilder(new ReleaseArtist()).withName('Mr Default Artist');
}
function aReleaseArtistV2() {
    return mockBuilder(new ReleaseArtistV2()).withName('Mr Default Artist').withOrder(0);
}
function aReleaseSongwriter() {
    return mockBuilder(new ReleaseSongwriter())
        .withName('Mr Default Songwriter')
        .withPublisherName('Default Publisher Name');
}
function aReleaseLyricist() {
    return mockBuilder(new ReleaseLyricist())
        .withName('Mr Default Lyricist')
        .withPublisherName('Default Publisher Name');
}
function aServiceProvider() {
    return mockBuilder({
        name: 'ITunes',
    });
}
function aPublisher() {
    return mockBuilder(new ReleasePublisher())
        .withName('Mr Default Publisher')
        .withEmail('defaultpublisher@email.com')
        .withPublishingHouse('Default Publishing House');
}
function aReleaseContributor() {
    return mockBuilder(new ReleaseContributor())
        .withRole(ReleaseContributorRoleEnum.Arranger)
        .withArtists([aReleaseArtist().withName('Mr Contributor')]);
}
function aReleaseStore() {
    return mockBuilder(new ReleaseStore())
        .withName(ReleaseStoreEnum.Spotify)
        .withCategory(ReleaseStoreCategoryEnum.Top)
        .withUsersCount(100)
        .withHasLogo(true);
}
function aReleaseError() {
    return mockBuilder(new ReleaseError('anErrorCode', 'An error message'));
}
function aReusedTrackInfos() {
    return mockBuilder(new ReusedTrackInfos())
        .withReleaseId('default-release-id')
        .withUnlockedFields([])
        .withUpcCode('default-upc-code')
        .withState('Released')
        .withSubmittedOrReleased(true);
}
function aReleaseTrack() {
    return mockBuilder(new ReleaseTrack('ca04b22b-6dca-4b08-ba36-4cce954cf8d3', 'Default release track name'))
        .withGenre('Reggae')
        .withSubGenre('Opera')
        .withIsrcCode('CACCC1701358')
        .withLanguage('en')
        .withPrimaryArtists([aReleaseArtist().withName('Mrs Default Track Primary').withId('default-track-primary-id')])
        .withLyricists([aReleaseLyricist()])
        .withMetadata({ trackId: 'ca04b22b-6dca-4b08-ba36-4cce954cf8d3' })
        .withCoverSongOptions(CoverSongOptionsEnum.OriginalComposition)
        .withIsCoverSong(false);
}
function aReleaseTrackCoverInfos() {
    return mockBuilder(new ReleaseTrackCoverInfos())
        .withOriginalTrackTitle('The Original Track')
        .withOriginalArtistsNames([
        aReleaseArtist().withName('The Original Artist'),
        aReleaseArtist().withName('The Second Original Artist'),
    ])
        .withOriginalSongwriters([
        aReleaseSongwriter()
            .withName('The Original Songwriter')
            .withPublisherName('The Original Songwriter Publisher'),
        aReleaseSongwriter()
            .withName('The Second Original Songwriter')
            .withPublisherName('The Second Original Songwriter Publisher'),
    ])
        .withOriginalTrackLink('https://url.com');
}
function aRelease() {
    return mockBuilder(new Release('33974d6f-4fca-4531-944e-2b05236c24a1', 'Default release name', '2017-06-02T14:21:20.958098+00:00'))
        .withGlobalState('Draft')
        .withState('Draft')
        .withUserId('f27bc505-92e6-4253-a8ce-b01518e2c52b')
        .withLastUpdateTime('2017-06-02T14:21:20.958098+00:00')
        .withMainGenre('Alternative')
        .withMainSubGenre('Holiday')
        .withUpcCode('123456007413')
        .withCatalogNumber('LR-1000578')
        .withReleaseFormat('Single')
        .withPrimaryArtists([aReleaseArtist().withName('Mrs Default Primary')])
        .withAdditionalArtists([aReleaseArtist().withName('Mr Default Additional')])
        .withCompositionOwner('Sir Default Composition Owner')
        .withCompositionYear(2017)
        .withMasterRecordingOwner('Sir Default Recording Owner')
        .withMasterRecordingYear(2017)
        .withSupplier('LANDR Audio Inc.')
        .withAutoGenerateLabel(true)
        .withLabel('LANDR')
        .withLanguage('en')
        .withHasOriginalReleaseDate(true)
        .withOriginalReleaseDate('2005-01-01T00:00:00.000Z')
        .withReleaseDate('2017-06-01T00:00:00.000000+00:00')
        .withServiceProviders([
        aServiceProvider().withName(ReleaseStoreEnum.ITunes),
        aServiceProvider().withName(ReleaseStoreEnum.Spotify),
    ])
        .withMonetizationEligibilityState(MonetizationEligibilityStateEnum.Requested);
}
function aReleaseServiceProviderState() {
    return mockBuilder(new ReleaseServiceProviderState())
        .withName(ReleaseStoreEnum.Spotify)
        .withCategory(ReleaseStoreCategoryEnum.Top)
        .withState(ServiceProviderStateEnum.Released);
}
function aReleaseTrendsDailyTotal() {
    return mockBuilder(new ReleaseTrendsDailyTotal()).withDate('1999-12-31').withDownloads(5).withStreams(50);
}

export { aPublisher, aRelease, aReleaseArtist, aReleaseArtistV2, aReleaseContributor, aReleaseError, aReleaseLyricist, aReleaseServiceProviderState, aReleaseSongwriter, aReleaseStore, aReleaseTrack, aReleaseTrackCoverInfos, aReleaseTrendsDailyTotal, aReusedTrackInfos, aServiceProvider };
